'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var Gift = function Gift(props) {
  var color = props.color,
    size = props.size,
    otherProps = _objectWithoutProperties(props, ['color', 'size']);
  return _react2.default.createElement('svg', _extends({
    xmlns: 'http://www.w3.org/2000/svg',
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: color,
    strokeWidth: '2',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }, otherProps), _react2.default.createElement('polyline', {
    points: '20 12 20 22 4 22 4 12'
  }), _react2.default.createElement('rect', {
    x: '2',
    y: '7',
    width: '20',
    height: '5'
  }), _react2.default.createElement('line', {
    x1: '12',
    y1: '22',
    x2: '12',
    y2: '7'
  }), _react2.default.createElement('path', {
    d: 'M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z'
  }), _react2.default.createElement('path', {
    d: 'M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z'
  }));
};
Gift.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};
Gift.defaultProps = {
  color: 'currentColor',
  size: '24'
};
exports.default = Gift;